import { SoliqModels, type ResDataSoliq } from '../types';

import { APISoliq } from './axiosClientSoliq';

export async function commissionCreate(data: { sign: string }): Promise<ResDataSoliq<SoliqModels.LoginRes | string>> {
  const response = await APISoliq.post<ResDataSoliq<SoliqModels.LoginRes | string>>('/commission-create', data);

  return response.data;
}

export async function getFactura(params: { tinOrPinfl: string }): Promise<ResDataSoliq<SoliqModels.Factura>> {
  const response = await APISoliq.get<ResDataSoliq<SoliqModels.Factura>>('/np1/bytin/factura', { params });

  return response.data;
}
export async function getWaybillTransports(params: {
  tinOrPinfl: string;
}): Promise<ResDataSoliq<SoliqModels.WaybillTransports[]>> {
  const response = await APISoliq.get<ResDataSoliq<{ data: SoliqModels.WaybillTransports[] }>>('/waybill-transports', {
    params,
  });
  return {
    data: response.data.data.data,
    success: response.data.success,
  };
}
export async function getGuid(): Promise<string> {
  const response = await APISoliq.get<ResDataSoliq<{ data: string; success: boolean }>>('/utils/guid');
  return response.data.data.data;
}
export async function getWaybillById(id: string): Promise<ResDataSoliq<SoliqModels.WaybillByIdRes>> {
  const response = await APISoliq.get<ResDataSoliq<{ data: SoliqModels.WaybillByIdRes; success: boolean }>>(
    `/waybill2/${id}`
  );
  return {
    data: response.data.data.data,
    success: response.data.success,
  };
}
export async function waybillSave(data: { dataJson: string }): Promise<ResDataSoliq> {
  const response = await APISoliq.post<ResDataSoliq>('/waybill2', data);
  return {
    data: response.data.data,
    success: response.data.success,
  };
}
export async function waybillSign(data: { sign: string }): Promise<ResDataSoliq> {
  const response = await APISoliq.post<ResDataSoliq>('/waybill2', data);
  return {
    data: response.data.data,
    success: response.data.success,
  };
}

export async function login(data: { sign: string }): Promise<ResDataSoliq<SoliqModels.LoginRes>> {
  const response = await APISoliq.post<ResDataSoliq<{ data: SoliqModels.LoginRes }>>('/login-tin', data);

  return {
    data: response.data.data.data,
    success: response.data.success,
  };
}

export async function getDocList(params: { docNo: string }): Promise<ResDataSoliq<any>> {
  const response = await APISoliq.get<ResDataSoliq<{ data: any[] }>>('/v2/lists', { params });
  return {
    data: response.data.data.data,
    success: response.data.success,
  };
}
